export const getManifestBoolean = (manifest, key, defaultValue = false) =>
    typeof manifest?.[key] === 'boolean' ? manifest[key] : defaultValue;
